// @ts-nocheck

import PropTypes from 'prop-types';
import * as R from 'ramda';
import React, { PureComponent } from 'react';

import Button from './Button';

class ButtonIcon extends PureComponent {
  static propTypes = {
    /**
     * One of material-icons: https://material.io/icons/
     */
    icon: PropTypes.string.isRequired,

    /**
     * style class to be applied on the icon only (not applied to the container)
     */
    iconClassName: PropTypes.string,

    /**
     * style class to be passed to the Button component along with 'core_icon'
     */
    className: PropTypes.string,

    /**
     * Any other props are passed directly down to the Button component
     */
  };

  static defaultProps = {
    iconClassName: '',
    className: 'core_icon',
    testid: 'icon',
  };

  render() {
    const { className, iconClassName, icon } = this.props;

    const buttonProps = R.omit(['className', 'icon', 'iconClassName'], this.props);

    return (
      <Button size="no-miw" className={className} {...buttonProps}>
        <i className={`${iconClassName} icon material-icons`}>{icon}</i>
      </Button>
    );
  }
}

export default ButtonIcon;
